import { createRoot } from 'react-dom/client'
import './utils/errorHandler' // Custom error handler for dev environment
import './index.css'
import './styles/responsive.css'
import './styles/responsive-components.css'
import App from './App.tsx'

// Handle chunk loading errors (deployment cache mismatch)
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk')
  ) {
    // Clear any cached data and reload
    console.warn('[ChunkError] Detected stale chunk, reloading page...');
    window.location.reload();
  }
});

// Handle unhandled promise rejections for dynamic imports
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('Failed to fetch dynamically imported module') ||
    event.reason?.message?.includes('Loading chunk')
  ) {
    console.warn('[ChunkError] Detected stale chunk in promise, reloading page...');
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <App />
)
